





import AbpBase from "@/lib/abpbase"
import {Component, Prop} from "vue-property-decorator"

@Component
export default class Choose extends AbpBase {
	/**
	 * 接收遍历的颜色
	 * */
	@Prop({type:Array}) shapes: any
	html = '&#xe66f;'
	selected = 0
	selectOne(index: number){
		this.selected = index
		this.$emit("pick", index)
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/chooseShape.vue